import axios from "axios";

const BASE_URL = "/m-1/user-client-hints";

/**
 * @typedef {Object} MappedHint
 * 
 * @property {number|string} key - The unique identifier for the hint.
 * @property {string} label - The content of the hint.
 * @property {MappedHint[]} nested - The nested children hints.
 */

/**
 * Recursively maps a raw user client hint to a nested tree structure.
 *
 * @param {any} hint - The raw hint object from the API.
 *
 * @returns {MappedHint} The mapped hint object.
 */
const mapItemToHint = (hint) => {
    const item = {
        "key": hint.id,
        "label": hint.content,
        "nested": hint.children.map((item) => {
            return mapItemToHint(item);
        }),
    };

    return item;
}

/**
 * Fetches all user client hints as a tree structure from the API.
 *
 * @returns {Promise<MappedHint[]>} A promise that resolves to the list of mapped user client hints.
 */
const get = async () => {
    const response = await axios.get(BASE_URL);
    const hints = Object.values(response.data);

    return hints.map(mapItemToHint);
}

/**
 * Service for interacting with User Client Hints API.
 */
export const UserClientHintService = {
    get,
}
